import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { Box } from '@bridebook/ui';
import { ABOUT_ME_SECTION_ID } from '@bridebook/web/app-shared/components/supplier/sections/ids';
import { fullDescriptionVisibility } from '@bridebook/web/app-shared/lib/supplier/utils/fullDescriptionVisibility';
import componentStyles from '@bridebook/web/app-basic/components/supplier/sections/description-short/description-short.style';

export interface IProps {
  supplier: ISupplier | undefined;
  isMobile: boolean;
  isTablet: boolean;
  button: React.ReactNode;
}

const DescriptionShort = ({ supplier, isMobile, isTablet, button }: IProps) => {
  const descriptionShort = supplier?.description?.short;
  if (!descriptionShort) return null;

  const showButton = fullDescriptionVisibility(supplier) && (isMobile || isTablet);

  const styles = componentStyles();

  return (
    <Box style={styles.wrapper} id={ABOUT_ME_SECTION_ID}>
      <Box style={styles.text}>{descriptionShort}</Box>
      {showButton && <Box style={styles.buttonWrap}>{button}</Box>}
    </Box>
  );
};

export default DescriptionShort;
